import { useRef } from 'react'
import { manifesto } from '@/content/site'
import { useReducedMotion } from '@/hooks/useReducedMotion'
import { EASE, gsap, SplitText, useGSAP } from '@/lib/gsap'
import styles from './Manifesto.module.css'

/** The closing line, as sentences: the first recedes a little, the second is the promise. */
const SENTENCES = manifesto.closing.split(/(?<=[.!?])\s+/)

/** Large, calm and final: masked lines rising once, nothing more. */
export function Closing() {
  const ref = useRef<HTMLParagraphElement>(null)
  const reducedMotion = useReducedMotion()

  useGSAP(
    () => {
      const root = ref.current
      if (!root) return
      if (reducedMotion) {
        gsap.from(root, {
          opacity: 0,
          duration: 0.3,
          ease: 'none',
          scrollTrigger: { trigger: root, start: 'top 88%', once: true },
        })
        return
      }
      SplitText.create(root, {
        type: 'lines',
        mask: 'lines',
        tag: 'span',
        aria: 'none',
        autoSplit: true,
        onSplit: (self) =>
          gsap.from(self.lines, {
            yPercent: 105,
            duration: 1.5,
            stagger: 0.1,
            ease: EASE.out,
            scrollTrigger: { trigger: root, start: 'top 80%', once: true },
          }),
      })
    },
    { scope: ref, dependencies: [reducedMotion], revertOnUpdate: true },
  )

  return (
    <p ref={ref} className={styles.closing}>
      {SENTENCES.map((sentence, index) => (
        <span
          key={index}
          className={index === 0 && SENTENCES.length > 1 ? styles.closingLead : styles.closingMain}
        >
          {sentence}
          {index < SENTENCES.length - 1 ? ' ' : null}
        </span>
      ))}
    </p>
  )
}
